import * as amplitude from "@amplitude/analytics-browser";
import { logStatsigEvent } from "../../services/googleTagManager";

// web40 intro screen events. Each goes to Amplitude (analysis) and Statsig
// (metrics), like the web41 reservation events.
export const WELCOME_KIT_EVENTS = {
  introViewed: "welcome_kit_intro_viewed",
  introCtaClicked: "welcome_kit_intro_cta_clicked",
} as const;

export function trackWelcomeKit(
  name: (typeof WELCOME_KIT_EVENTS)[keyof typeof WELCOME_KIT_EVENTS],
  props?: Record<string, string | number | boolean | undefined>
): void {
  amplitude.track(name, props);
  logStatsigEvent(name, undefined, props);
}
